export default "__VITE_ASSET__5RxLOSF$__"